module.exports = __webpack_public_path__ + "img/241-8c73a0.png";